var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseContainedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/x-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.5999C17.3018 21.5999 21.5999 17.3018 21.5999 11.9999C21.5999 6.69797 17.3018 2.3999 11.9999 2.3999C6.69797 2.3999 2.3999 6.69797 2.3999 11.9999C2.3999 17.3018 6.69797 21.5999 11.9999 21.5999ZM9.9363 8.66351C9.58483 8.31203 9.01498 8.31203 8.66351 8.66351C8.31203 9.01498 8.31203 9.58483 8.66351 9.9363L10.7271 11.9999L8.66351 14.0635C8.31203 14.415 8.31203 14.9848 8.66351 15.3363C9.01498 15.6878 9.58483 15.6878 9.9363 15.3363L11.9999 13.2727L14.0635 15.3363C14.415 15.6878 14.9848 15.6878 15.3363 15.3363C15.6878 14.9848 15.6878 14.415 15.3363 14.0635L13.2727 11.9999L15.3363 9.9363C15.6878 9.58483 15.6878 9.01498 15.3363 8.66351C14.9848 8.31203 14.415 8.31203 14.0635 8.66351L11.9999 10.7271L9.9363 8.66351Z",
    fill: "#7A7888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseContainedIcon);
export default __webpack_public_path__ + "static/media/CloseContainedIcon.cee54622b78f856045123671b28e063c.svg";
export { ForwardRef as ReactComponent };